import React, { useState } from 'react';
import './LineaTiempo.css';

const LineaTiempo = ({ eventos }) => {
  const [currentPage, setCurrentPage] = useState(0);
  if (!eventos || eventos.length === 0) {
    return <p className="empty-timeline">No hay eventos registrados</p>;
  }

  const getEstadoLabel = (estado) => {
    const labels = {
      elaborado: 'Elaborado',
      por_revision: 'Por Revisión',
      aprobado_vicepresidencia: 'Aprobado por VP',
      rechazado_vicepresidencia: 'Rechazado por VP',
      recibido_administracion: 'Recibido por Administración',
      aprobado_administracion: 'Aprobado por Administración',
      rechazado_administracion: 'Rechazado por Administración',
      pagado_parcial: 'Pagado Parcial',
      pagado: 'Pagado',
    };
    return labels[estado] || estado;
  };

  const getRolLabel = (rol) => {
    const labels = {
      presidente: 'Presidente',
      vp_comercial: 'VP Comercial',
      vp_operativa: 'VP Operativa',
      vp_administrativa: 'VP Administrativa',
      analista_comercial: 'Analista Comercial',
      analista_operaciones: 'Analista Operaciones',
      analista_administrativo: 'Analista Administrativo',
    };
    return labels[rol] || rol;
  };

  const getAccionLabel = (accion) => {
    const labels = {
      creacion: 'Creación',
      cambio_estado: 'Cambio de Estado',
      asignacion_criticidad: 'Asignación de Criticidad',
      asignacion_proveedor: 'Asignación de Proveedor',
      edicion: 'Edición',
      pago: 'Marcado como Pagado',
    };
    return labels[accion] || accion;
  };

  const labelCampos = {
    estado: 'Estado',
    monto_bs: 'Monto (Bs.)',
    monto_usd_creacion: 'Monto USD (Creación)',
    tasa_bcv_creacion: 'Tasa BCV (Creación)',
    monto_usd_aprobacion: 'Monto USD (Aprobación)',
    tasa_bcv_aprobacion: 'Tasa BCV (Aprobación)',
    solicitante_cedula: 'Cédula Solicitante',
    solicitante_nombre: 'Nombre Solicitante',
    solicitante_apellido: 'Apellido Solicitante',
    solicitante_telefono: 'Teléfono Solicitante',
    criticidad: 'Criticidad',
    descripcion: 'Descripción',
    proveedor_nombre: 'Nombre Proveedor',
    proveedor_rif: 'RIF Proveedor',
    pago_movil_banco: 'Banco Pago Móvil',
    pago_movil_telefono: 'Teléfono Pago Móvil',
    pago_movil_cedula: 'Cédula Pago Móvil',
  };

  const formatValue = (key, val) => {
    if (val === null || val === undefined) return 'N/A';
    if (key === 'criticidad') {
      const critLabels = { alta: 'Alta 🔴', media: 'Media 🟡', baja: 'Baja 🟢' };
      return critLabels[val] || val;
    }
    if (key === 'monto_bs' || key === 'monto_usd_creacion' || key === 'monto_usd_aprobacion') {
      return parseFloat(val).toLocaleString('es', { minimumFractionDigits: 2 });
    }
    return val.toString();
  };

  const renderDiff = (datosAnteriores, datosNuevos) => {
    if (!datosNuevos) return null;
    const keys = Object.keys(datosNuevos);
    const diffs = [];

    keys.forEach(key => {
      const valNuevo = datosNuevos[key];
      const valAnterior = datosAnteriores ? datosAnteriores[key] : null;

      if (valNuevo !== valAnterior) {
        const fieldLabel = labelCampos[key] || key;
        const valNuevoFmt = formatValue(key, valNuevo);
        
        if (valAnterior !== null && valAnterior !== undefined && valAnterior !== '') {
          const valAnteriorFmt = formatValue(key, valAnterior);
          diffs.push(
            <div key={key} className="diff-item">
              <strong>{fieldLabel}:</strong> <span className="diff-old">{valAnteriorFmt}</span> → <span className="diff-new">{valNuevoFmt}</span>
            </div>
          );
        } else {
          diffs.push(
            <div key={key} className="diff-item">
              <strong>{fieldLabel}:</strong> <span className="diff-new">{valNuevoFmt}</span>
            </div>
          );
        }
      }
    });

    if (diffs.length === 0) return null;

    return (
      <div className="evento-diffs">
        <div className="diff-title">Auditoría de Datos:</div>
        {diffs}
      </div>
    );
  };

  const totalPages = eventos.length;
  const eventoActual = eventos[currentPage];

  return (
    <div className="linea-tiempo-container">
      <div className="linea-tiempo">
        <div key={eventoActual.id || currentPage} className="evento">
          <div className="evento-linea">
            <div className="evento-punto" />
          </div>
          <div className="evento-content">
            <div className="evento-header">
              <span className="evento-fecha">
                📅 {new Date(eventoActual.fecha).toLocaleString('es')}
              </span>
              {eventoActual.accion && (
                <span className="evento-nivel">
                  {getAccionLabel(eventoActual.accion)}
                </span>
              )}
            </div>
            
            <div className="evento-estados">
              {eventoActual.estado_anterior && (
                <span className="estado-anterior">
                  {getEstadoLabel(eventoActual.estado_anterior)}
                </span>
              )}
              {eventoActual.estado_anterior && <span className="evento-flecha">→</span>}
              <span className="estado-nuevo">
                {getEstadoLabel(eventoActual.estado_nuevo)}
              </span>
            </div>

            <div className="evento-usuario">
              👤 <strong>{eventoActual.usuario_nombre || eventoActual.usuario_username}</strong> 
              {eventoActual.rol_usuario && ` (${getRolLabel(eventoActual.rol_usuario)})`}
              {eventoActual.vicepresidencia_nombre && ` - ${eventoActual.vicepresidencia_nombre}`}
            </div>

            {eventoActual.comentario && (
              <div className="evento-comentario">
                💬 {eventoActual.comentario}
              </div>
            )}

            {renderDiff(eventoActual.datos_anteriores, eventoActual.datos_nuevos)}

            <div className="evento-meta">
              {eventoActual.ip_address && (
                <span className="evento-meta-item">
                  🌐 IP: {eventoActual.ip_address}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {totalPages > 1 && (
        <div className="linea-tiempo-pagination">
          <button 
            type="button"
            className="btn btn-secondary" 
            onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
            disabled={currentPage === 0}
          >
            ← Anterior
          </button>
          <span className="pagination-info">
            Paso {currentPage + 1} de {totalPages}
          </span>
          <button 
            type="button"
            className="btn btn-secondary" 
            onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))}
            disabled={currentPage === totalPages - 1}
          >
            Siguiente →
          </button>
        </div>
      )}
    </div>
  );
};

export default LineaTiempo;
